import { STATUS_CONFIRMED } from 'constants/orderStatuses'
import { Col } from '@trybeapp/ui.grid'
import { DateTime } from 'luxon'
import { StatusTag } from './Overview'
import { ArrowNarrowLeftIcon } from '@heroicons/react/solid'
import { Text } from '@trybeapp/ui.text'
import { ArrowNarrowRightIcon } from '@heroicons/react/outline'
import { useGetBookingEngineRates } from 'api/Integrations'

export const StatusColumn = ({ item, ...props }) => {
  return (
    <Col col={0.13} {...props}>
      <StatusTag status={STATUS_CONFIRMED} />
    </Col>
  )
}

export const DateColumn = ({ item }) => {
  const { item_configuration: item_configration = {} } = item
  const { check_in_date: check_in_date } = item_configration
  const { check_out_date: check_out_date } = item_configration

  return (
    <Col col={0.15}>
      <div className="flex items-center text-sm">
        <ArrowNarrowRightIcon className="h-4 w-4 text-green-500 mr-1" />
        <span>{DateTime.fromISO(check_in_date).toLocaleString()}</span>
      </div>
      <div className="flex items-center text-sm mt-1">
        <ArrowNarrowLeftIcon className="h-4 w-4 text-red-500 mr-1" />
        <span>{DateTime.fromISO(check_out_date).toLocaleString()}</span>
      </div>
    </Col>
  )
}

export const PackageItemTypeColumn = ({ item, children }) => {
  const { offering_name: offering_name } = item

  return (
    <Col col={0.35}>
      <span className="text-sm">{offering_name}</span>
      {children}
    </Col>
  )
}

export const StartTimeColumn = ({ item }) => {
  //start time is not supported for hotel room bookings so we just return an empty column

  return (
    <Col col={0.12}>
      <div className="flex flex-col">
        <span className="text-sm"></span>
      </div>
    </Col>
  )
}

export const BookingResourceSummary = ({ item }) => {
  const { item_configuration: item_configuration } = item
  const { data } = useGetBookingEngineRates()

  const options = (data?.data ?? []).map((rate) => ({
    value: rate.id,
    name: rate.name,
    description: rate.code,
  }))

  const value = options.length
    ? options.find((option) => option.value === item_configuration.rate_id)
    : null

  // make a string that shows num guests & rate, account for guest/guests wording
  const resourceString = `${item_configuration.num_guests} guests @ rate ${value?.name || 'N/A'}`

  return (
    <Text variant="meta1" color="nude.500" lineHeight={1.2}>
      {resourceString}
    </Text>
  )
}
